'use strict' /* eslint-disable no-console */;

const scrollClassToggle = (function() {
  // let direction = '';
  let miniCtaBoxHeight = 0;

  /**
	* isMobile
	*
	* get target element offset from screenTop
	*/
  function isMobile() {
    const windowWidth = window.innerWidth;
    const threshold = 992;
    return windowWidth < threshold;
  }

  /**
	* getScrollTop
	*
	* get target element offset from screenTop
	*/
  function getScrollTop() {
    return window.scrollY;
  }

  /**
	* getScrollBottom
	*
	* get target element offset from screenTop
	*/
  function getScrollBottom() {
    const windowHeight =
      document.compatMode == 'CSS1Compat' && !window.opera
        ? document.documentElement.clientHeight
        : document.body.clientHeight;

    return window.scrollY + windowHeight;
  }

  /**
	* getElementTop
	*
	* get target element offset from screenTop
	* @param element: target html element
	*/
  function getElementTop(target) {
    const rect = target.getBoundingClientRect();

    return window.scrollY + rect.top;
  }

  /**
	* getElementBottom
	*
	* get target element offset from screenBottom
	* @param element: target html element
	*/
  function getElementBottom(target) {
    const rect = target.getBoundingClientRect();

    return window.scrollY + rect.bottom;
  }

  /**
	* getElementHeight
	*
	* get target element offset from screenBottom
	* @param element: target html element
	*/
  function getElementHeight(target) {
    const rect = target.getBoundingClientRect();

    return rect.height;
  }

  /**
	* getElementsArr
	*
	* get distance between each element's bottom
	* NOTE: Selector string is supposed to have only 2 selectors.
	*
	* @param targetSelectors: string of selectors connected with comma
	*/
  function getElementsArr(targetSelectors) {
    const targetSelectorsArr = targetSelectors.split(/,/);
    let elementsArr = [];

    [].forEach.call(targetSelectorsArr, (selector, index) => {
      elementsArr[index] = document.querySelector(targetSelectorsArr[index]);
    });

    return elementsArr;
  }

  /**
	* getDistanceBottom
	*
	* get distance between each element's bottom
	* NOTE: Selector string is supposed to have only 2 selectors.
	*
	* @param targetSelectors: string of selectors connected with comma
	*/
  function getDistanceBottom(elements) {
    let offsets = [];

    [].forEach.call(elements, (element, index) => {
      offsets[index] = getElementBottom(element);
    });

    return offsets[0] - offsets[1];
  }

  /**
	* setMiniCtaBoxHeight
	*
	* get distance between each element's bottom
	*/
  function setMiniCtaBoxHeight() {
    const ctaBox = document.querySelector('.js-title-cta');
    const ctaBoxHeight = getElementHeight(ctaBox);
    const ctaImage = document.querySelector('.js-title-cta .block-centered');
    const ctaImageHeight = getElementHeight(ctaImage);
    // console.log({ ctaImage })
    // console.log({ ctaBoxHeight})
    // console.log({ctaImageHeight});

    miniCtaBoxHeight = ctaBoxHeight - ctaImageHeight;
  }

  function addClass(element, className) {
    if (!element.classList.contains(className))
      element.classList.add(className);
  }

  function removeClass(element, className) {
    if (element.classList.contains(className))
      element.classList.remove(className);
  }

  /**
	* enterHandler
	*
	* toggle classes when ENTERING the target element
	* @param targetOffsetTop: distance between screenTop and elementTop
	* @param element: target html element
	* @param toggleClass: class to be toggled
	*/
  function enterHandler(target, gutter, outgutter, element, className) {
    const targetTop = getElementTop(target);
    // const targetBottom = getElementBottom(target);
    const targetHeight = getElementHeight(target);
    const scrollTop = getScrollTop();
    // const scrollBottom = getScrollBottom();
    const windowHeight =
      document.compatMode == 'CSS1Compat' && !window.opera
        ? document.documentElement.clientHeight
        : document.body.clientHeight;

    if (scrollTop >= targetTop + gutter) {
      addClass(element, className);
    }
    if (scrollTop >= targetTop + gutter && targetHeight < windowHeight) {
      addClass(element, className);
    }
    if (scrollTop < targetTop + gutter) {
      // Before entering
      removeClass(element, className);
    }
  }

  /**
	* exitHandler
	*
	* toggle classes when ENTERING the target element
	* @param targetOffsetTop: distance between screenTop and elementTop
	* @param element: target html element
	* @param toggleClass: class to be toggled
	*/
  function exitHandler(target, gutter, element, toggleClass, outClass) {
    const targetTop = getElementTop(target);
    const targetBottom = getElementBottom(target);
    const scrollTop = getScrollTop();
    const scrollBottom = getScrollBottom();

    const ctaRectY = document
      .querySelector('.js-title-cta')
      .getBoundingClientRect().y;

    if (scrollBottom >= targetBottom + gutter && scrollTop >= targetTop) {
      // removeClass(element, toggleClass);
      addClass(element, outClass);
    }
    if (scrollBottom < targetBottom + gutter && scrollTop >= targetTop) {
      removeClass(element, outClass);
      addClass(element, toggleClass);
      // removeClass(element, 'sticky-bottom');
    }
    if (
      (scrollBottom < targetBottom + gutter && scrollTop >= targetTop) ||
      ctaRectY > 40
    ) {
      removeClass(element, 'sticky-bottom');
    }
  }

  /**
	* distanceHandler
	*
	* toggle classes when ENTERING the target element
	* @param targetOffsetTop: distance between screenTop and elementTop
	* @param element: target html element
	* @param toggleClass: class to be toggled
	*/
  function distanceHandler(elements, gutter, element, className) {
    const distance = getDistanceBottom(elements);

    if (distance >= gutter) {
      addClass(element, className);
    } else {
      removeClass(element, className);
    }
  }

  // function getScrollDirection() {
  // 	let previous = window.scrollY;
  // 	window.addEventListener('scroll', function(){
  // 		direction = (window.scrollY > previous) ? 'down' : 'up';
  // 		previous = window.scrollY;
  // 	});
  // }

  /**
	* imageFlatteningHandler
	*
	* handles image-box flattening interaction in CTA Box
	* NOTE: Since this handler/interaction is related to many elements position, it's independent method for now. But ideally be methodlized
	*/
  function imageFlatteningHandler() {
    // CTA Box variables
    // const ctaBox = document.querySelector('.js-title-cta');
    const ctaBoxFixedTop = 40;

    // CTA Image variables
    const ctaImageClass = '.js-title-cta .cta__top-image';
    const ctaImage = document.querySelector(ctaImageClass);

    if (ctaImage) {
      const ctaImageSetHeight = 360;
      const ctaImageBottomCurrent =
        getScrollTop() + ctaImageSetHeight + ctaBoxFixedTop;

      // Sub Header
      const subHeader = document.querySelector('.js-title-header');
      const subHeaderTop = getElementTop(subHeader);

      // Conditions
      const inArea = ctaImageBottomCurrent > subHeaderTop;
      const inHero = getScrollTop() < subHeaderTop - ctaBoxFixedTop;

      // Percentage calculation
      const percentage =
        (subHeaderTop - (getScrollTop() + ctaBoxFixedTop)) / ctaImageSetHeight;

      if (isMobile()) {
        ctaImage.style.height = 0;
      } else {
        if (inArea && inHero) {
          const height = ctaImageSetHeight * percentage;
          ctaImage.style.height = height;
        } else if (!inArea && inHero) {
          ctaImage.style.height = '';
        } else if (inArea && !inHero) {
          ctaImage.style.height = 0;
        }
      }
    }
  }

  /**
	* fixedCancellationHandler
	*
	* handles image-box flattening interaction in CTA Box
	* NOTE: Since this handler/interaction is related to many elements position, it's independent method for now. But ideally be methodlized
	*/
  function fixedCancellationHandler() {
    // Adjustments
    const limit = 1000;
    const buffer = -(
      document.querySelector('.js-title-cta .card').scrollHeight - 97
    );
    const ctaBoxFixedTop = 40;

    // Title Contents
    const titleContents = document.querySelector('.js-title-contents');
    const titleContentsBottom = getElementBottom(titleContents);

    // CTA Box variables
    const ctaBox = document.querySelector('.js-title-cta');
    // const ctaBoxBottom = getElementBottom(ctaBox);
    const ctaBoxBottom = getScrollTop() + miniCtaBoxHeight + ctaBoxFixedTop;

    // Condition
    const diff = ctaBoxBottom - (titleContentsBottom + buffer);

    if (isMobile()) {
      ctaBox.style.transform = '';
    } else {
      if (diff >= 0 && diff < limit) {
        ctaBox.style.transform = 'translate(0, ' + -diff + 'px)';
      } else if (diff >= 0 && diff >= limit) {
        ctaBox.style.transform = 'translate(0,' + -limit + 'px)';
      } else {
        ctaBox.style.transform = '';
      }
    }
  }

  /**
	* scrollHandler
	*
	* @param setting: object including attributes below
	* 	targetElement: Target section defining in or out,
	* 	toggleClass: Class Name when entering the section
	* 	toggleElement: Css Selector class being added or removed (optional)
	* 	outClass: Class Name when scrolling past the section (optional)
	*/
  function scrollHandler(setting) {
    const toggleClass = setting.toggleClass;
    const outClass = setting.outClass ? setting.outClass : '';
    const gutter = setting.gutter ? setting.gutter : 0;
    const outGutter = setting.outGutter ? setting.outGutter : 0;
    const toggleSelectors = (setting.toggleElement
      ? setting.toggleElement
      : setting.targetElement
    ).split(/,/);

    switch (setting.mode) {
      // ------------------------------ 01. Distance
      case 'distance': {
        const targetElements = getElementsArr(setting.targetElement);

        toggleSelectors.forEach(selector => {
          const toggleElement = document.querySelector(selector);
          distanceHandler(targetElements, gutter, toggleElement, toggleClass);
        });
        break;
      }

      // ------------------------------ 02. Image-flattening
      case 'image-flattening':
        imageFlatteningHandler();
        break;

      // ------------------------------ 03. Position-fixed Cancellation
      case 'fixed-cancellation':
        fixedCancellationHandler();
        break;

      // ------------------------------ 04. Enter/Exit
      default: {
        const targetElement = document.querySelector(setting.targetElement);

        [].forEach.call(toggleSelectors, selector => {
          const toggleElement = document.querySelector(selector);

          // Entering the section
          enterHandler(
            targetElement,
            gutter,
            outGutter,
            toggleElement,
            toggleClass
          );
          // Exiting the section
          if (outClass)
            exitHandler(
              targetElement,
              outGutter,
              toggleElement,
              toggleClass,
              outClass
            );
        });
      }
    }
  }

  const reset = function() {
    setMiniCtaBoxHeight();

    if (isMobile()) {
      //
    }
  };

  const init = function(setting) {
    // listen to scroll event for sticky navigation
    // window.addEventListener('scroll', _.throttle(function(){ scrollHandler(setting); }, 100));
    const ctaBox = document.querySelector('.js-title-cta');
    if (ctaBox) {
      // getScrollDirection();
      setMiniCtaBoxHeight();

      if (document.querySelector(setting.targetElement) != null)
        window.addEventListener('scroll', () => {
          scrollHandler(setting);
        });

      window.addEventListener('resize', reset);
    }
  };

  return {
    init: init,
    getElementBottom: getElementBottom,
    addClass: addClass,
    removeClass: removeClass,
  };
})();

export default scrollClassToggle;



// WEBPACK FOOTER //
// ./resources/assets/js/scroll-class-toggle.js